import React from "react";
import {
  Col,
  FormControl,
  InputGroup,
  FormGroup,
  Image,
} from "react-bootstrap";

export default ({
  style,
  InputHeadTitle,
  onChange,
  placeholder,
  disabled,
  name,
  value,
  type,
  image,
  textArea,
  inputDes,
  textLimit,
  headBtn,
  onHeadBtn,
  preText,
  pattern,
  required,
  headtitleInUnder,
}) => {
  style = style ? style : {};
  style.border = "none";

  return (
    <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0%" }}>
      {InputHeadTitle ? (
        <div
          style={{
            fontSize: style?.headTitle?.fontSize
              ? style?.headTitle?.fontSize
              : "24px",
            color: style?.headTitle?.color ? style?.headTitle?.color : "#000",
            marginBottom: style?.headTitle?.marginBottom
              ? style?.headTitle?.marginBottom
              : "14px",
            fontWeight: style?.headTitle?.fontWeight
              ? style?.headTitle?.fontWeight
              : "",
            fontFamily: style?.headTitle?.fontFamily
              ? style?.headTitle.fontFamily
              : "",
          }}
          className="flex-between-center"
        >
          <div>{InputHeadTitle}</div>
          {headBtn ? (
            <div
              className="green-txt flex-center-center"
              style={{
                width: "85px",
                height: "36px",
                borderRadius: "6px",
                border: "solid 2px #2cb46d",
                fontSize: "16px",
              }}
              onClick={onHeadBtn}
            >
              {headBtn}
            </div>
          ) : (
            ""
          )}
        </div>
      ) : null}
      {inputDes ? (
        <div
          style={{ marginBottom: "15px", fontSize: "14px", color: "#1c1c1c" }}
        >
          {inputDes}
        </div>
      ) : (
        ""
      )}
      <FormGroup
        controlId="search"
        className={`${
          disabled ? "disabled-input-field" : ""
        } form_search common-input-comp ${required ? "required-style" : ""}`}
        style={{ ...style?.UnderStyleP }}
      >
        {headtitleInUnder ? (
          <div style={{ ...style?.headtitleInUnderStyle }}>
            {headtitleInUnder}
          </div>
        ) : (
          ""
        )}
        <InputGroup
          style={{
            border: !style?.headtitleInUnderStyle
              ? style.borderGroup
                ? style.borderGroup
                : "0.08em solid #ced4da"
              : "none",
            backgroundColor: disabled
              ? "#f4f4f4"
              : style.backgroundColor
              ? style.backgroundColor
              : "#fff",
            borderRadius: "5px",
          }}
        >
          {preText ? (
            <InputGroup.Append
              style={{
                background: "none",
                border: "none",
                padding: "0 3px",
                paddingRight: "10px",
                paddingBottom: textLimit ? "18px" : "",
              }}
              className={textLimit ? "flex-center-end" : "flex-center-center"}
            >
              <div
                style={{
                  fontWeight: "500",
                  color: "#000",
                  borderRight: "1px solid #ccc",
                  width: "60px",
                  height: "50%",
                }}
                className="flex-center-center"
              >
                {preText}
              </div>
            </InputGroup.Append>
          ) : null}
          {/* {style.headtitleInUnderStyle ? (style.border = "none") : ""} */}
          <FormControl
            style={style}
            type={type}
            as={textArea ? "textarea" : "input"}
            placeholder={placeholder ? placeholder : ""}
            value={value}
            name={name}
            onChange={(e) => onChange(e)}
            disabled={disabled}
          />
          {image || textLimit ? (
            <InputGroup.Append
              style={{
                background: "none",
                border: "none",
                padding: "0 3px",
                paddingRight: "10px",
                paddingBottom: textLimit ? "18px" : "",
              }}
              className={textLimit ? "flex-center-end" : "flex-center-center"}
            >
              {textLimit ? (
                <div
                  style={{
                    fontFamily: "OpenSans, Arial, sans-serif",
                    fontWeight: "600",
                    color: "#007ab5",
                    fontSize: "14px",
                  }}
                >
                  {textLimit - value?.length}
                </div>
              ) : (
                <Image
                  style={{
                    height: style?.imageheight ? style.imageheight : "20px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  }}
                  src={image}
                />
              )}
            </InputGroup.Append>
          ) : null}
        </InputGroup>
      </FormGroup>
    </Col>
  );
};
